/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SsoUsernameDecollisionEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SSO_USERNAME_DECOLLISION_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class SsoUsernameDecollisionEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SsoUsernameDecollisionEnabledSettingParser.decode(input).map(res => new SsoUsernameDecollisionEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return SsoUsernameDecollisionEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SsoUsernameDecollisionEnabledSettingParser.encode(data);
    }
    static schema() {
        return SsoUsernameDecollisionEnabledSettingParser.schema();
    }
}
